import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectZipCode } from '../reducers/zipCodeReducer';
import useFetchOffers from '../hooks/useFetchOffers';
import { offersDagLoad } from '../utils/analyticsEventListeners';
import OffersList from './OffersList';
import { useValidateZipCode } from '../hooks/useValidateZipCode';
import { setOffers } from '../reducers/offersReducer';

const Offers: React.FC = () => {
  const dispatch = useDispatch();

  const { confirmedZipcode } = useSelector(selectZipCode);

  const { loading, offers } = useFetchOffers(confirmedZipcode);

  const confirmedZipFromSessionStorage = sessionStorage.getItem('validZipCode');

  const { setAlreadyValidZip } = useValidateZipCode();

  // Saving offers to Redux
  useEffect(() => {
    if (!offers) return;
    dispatch(setOffers(offers));
  }, [dispatch, offers]);

  // Saving zip to redux
  useEffect(() => {
    if (confirmedZipFromSessionStorage) {
      setAlreadyValidZip(confirmedZipFromSessionStorage);
    }
  }, [confirmedZipFromSessionStorage, setAlreadyValidZip]);

  // Sending dag event to IXIS
  useEffect(() => {
    if (!offers?.length) return;
    const ixisEvent = {
      dealerAdGroup: offers[0].zipClusterID,
      visitorZipCode: confirmedZipcode,
    };
    offersDagLoad(ixisEvent);
  }, [confirmedZipcode, offers]);

  return <OffersList loading={loading} />;
};

export default Offers;
